var _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _path, _path2, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 24,
    width: 60,
    height: 102,
    rx: 12,
    fill: "#fff",
    stroke: "#F97316",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 40,
    width: 44,
    height: 60,
    rx: 4,
    fill: "#FFF7ED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 114,
    r: 4,
    fill: "#F97316"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 48,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#FDBA74"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 48,
    width: 12,
    height: 16,
    rx: 3,
    fill: "#FFEDD5",
    stroke: "#F97316"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 70,
    width: 12,
    height: 16,
    rx: 3,
    fill: "#FFEDD5",
    stroke: "#F97316"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 70,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#F59E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196 44a26 26 0 0 1 0 62",
    stroke: "#FDBA74",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202 56a14 14 0 0 1 0 38",
    stroke: "#F97316",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 120,
    r: 9,
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215 116v8M211 120h8",
    stroke: "#F59E0B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.793d9398602d64f3f0ae106967d06d9e.svg";
export { ForwardRef as ReactComponent };